<select *ngIf="!no_select" class="form-control form-control-sm"  name="{{name}}" [(ngModel)]="value" (ngModelChange)="onChange()" [class.alert-info]="value!=''">    
    <option *ngFor="let t of tables" value="{{t.table}}">{{t.label}}</option>
    <option value="" *ngIf="show_all">Tutte le sezioni</option> 
</select>
<span *ngIf="no_select">
    <span *ngIf="checkTable(value)">{{checkTable(value)}}</span>    
    <span *ngIf="!checkTable(value)">[{{value}}]</span>
</span>